import { render } from "./Dokumentarchiv.vue?vue&type=template&id=ebc3aeee&scoped=true&ts=true"
import script from "./Dokumentarchiv.vue?vue&type=script&lang=ts"
export * from "./Dokumentarchiv.vue?vue&type=script&lang=ts"

import "./Dokumentarchiv.vue?vue&type=style&index=0&id=ebc3aeee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc3aeee"]])

export default __exports__